import React, { Component } from "react";
import classNames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { IconSize } from "@formant/ui/component/common/Icon";

import { FlexSpacer } from "./FlexSpacer";
import { Help } from "./Help";
import styles from "./Switch.scss";

export interface ISwitchProps extends ITestableComponentProps {
    state: boolean;
    onChange?: (newState: boolean) => void;
    className?: string;
    infoClassName?: string;
    label?: string;
    stateLabels?: [string, string];
    info?: string | [string, string];
    disabled?: boolean;
    small?: boolean;
    link?: string;
    iconSize?: IconSize;
}

export class Switch extends Component<ISwitchProps> {
    public render() {
        const {
            className,
            infoClassName,
            state,
            label,
            stateLabels,
            info,
            disabled,
            small,
            link,
            iconSize,
        } = this.props;

        let infoText: string | undefined;
        if (typeof info === "string") {
            infoText = info;
        } else if (typeof info === "object") {
            infoText = info[state ? 1 : 0];
        }

        return (
            <div
                onClick={!disabled ? this.onChange : undefined}
                className={classNames(
                    styles.switch,
                    state && styles.on,
                    disabled && styles.disabled,
                    small && styles.small,
                    className,
                )}
                data-testid={this.props["data-testid"]}
            >
                <div className={infoClassName}>
                    {label && <div className={styles.label}>{label}</div>}
                    {infoText && (
                        <div className={styles.info}>
                            <Help text={infoText} to={link} size={iconSize} />
                        </div>
                    )}
                </div>
                <FlexSpacer />
                {stateLabels && (
                    <div className={styles["state-label"]}>
                        <div className={styles["state-label-block"]}>
                            {stateLabels[0]}
                        </div>
                        <div className={styles["state-label-block"]}>
                            {stateLabels[1]}
                        </div>
                        {stateLabels[Number(state)]}
                    </div>
                )}
                <div className={styles["toggle-container"]}>
                    <div className={styles.background} />
                    <div className={styles.foreground} />
                </div>
            </div>
        );
    }

    public onChange = () => {
        const { state, onChange } = this.props;
        const newState = !state;
        onChange?.(newState);
    };
}
